var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFhsRedArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 5,
    viewBox: "0 0 6 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69423 0.071777L1.63911 0.0717772C1.06027 0.0717773 0.699617 0.699687 0.991279 1.19968L2.51884 3.81835C2.80824 4.31448 3.52509 4.31448 3.8145 3.81835L5.34206 1.19968C5.63372 0.699688 5.27307 0.071777 4.69423 0.071777Z",
    fill: "#B62D23"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFhsRedArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FHS_red_arrow_down.592a8b77174de20e6ea2f8c46dc705de.svg";